import React from "react";
import "./Team.css";

const Team = () => {
  const teamMembers = [
    {
      name: "Eng. Ali AlAwaji",
      role: "Chief Executive Officer",
      location: "Riyadh, Saudi Arabia",
      image: "/Ali Awaji.jpeg", // Replace with the correct path to the image
      linkedin: "https://www.linkedin.com/in/ali-alawaji-690aa5331/", // Replace with the LinkedIn profile link
      email: "ali.alawaji@example.com", // Replace with the email
    },

  ];

  return (
    <div className="executive-team-page">
      <h1 className="executive-team-title">OGITS Board Team</h1>
      <div className="executive-team-container">
        {teamMembers.map((member, index) => (
          <div key={index} className="team-member">
            <img src={member.image} alt={member.name} className="team-member-image" />
            <div className="team-member-info">
              <h3 className="team-member-name">{member.name}</h3>
              <p className="team-member-role">{member.role}</p>
              <p className="team-member-location">{member.location}</p>
              <div className="team-member-links">
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="linkedin-link"
                >
                  LinkedIn
                </a>
                <a href={`mailto:${member.email}`} className="email-link">
                  Email
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Team;
